import React, { memo, useEffect, useState } from 'react';
import {
  View,
  StatusBar,
  SafeAreaView,
  Text,
  NativeModules,
  Platform,
  StyleSheet,
} from 'react-native';
import { NOTIFICATION_ICON, CHEVRON_LEFT } from '../../assets'; // Ensure BACK_ICON is available
import { useDispatch, useSelector } from 'react-redux';
import { getCleanUrl, isAndroid } from '../../utils/Helper';
import { ImageComp } from '../Image/Image';
import CustomPressable from '../customPressable/customPressable';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { setGoHome } from '../../Redux/Reducers/appConfigReducer';
import LinearGradient from 'react-native-linear-gradient';

const { StatusBarManager } = NativeModules;

const HeaderWithBack = (props) => {

  const { customBackText, handleCustomBackPress, customCancelText, handleCustomCancelClick, hideBackButton=false } = props || {};

  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const { t } = useTranslation();

  const { webAppWidgetsInfo, currentLayout } = useSelector(state => state.deviceConfigSlice);

  const [statusBarHeight, setStatusBarHeight] = useState(0);


  const hotelLogoImageUrl = getCleanUrl(currentLayout?.brandingInfo?.hotelLogoImageUrl)

  const handleBackPress = () => {    
    if (handleCustomBackPress) {
      handleCustomBackPress();
      return;
    }

    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }

    dispatch(setGoHome(true));
  };


  const getStatusBarHeight = () => {
    if (Platform.OS === 'ios') {
      StatusBarManager.getHeight((height) => setStatusBarHeight(height.height || 0));
    } else {
      setStatusBarHeight(StatusBar.currentHeight || 0);
    }
  }


  useEffect(() => {
    getStatusBarHeight();

  }, [])

  return (
    <View style={getStyles([{ paddingTop: statusBarHeight }, 'headerContainer', 'headerContainerWithBack'])} id='headerContainer headerContainerWithBack'>

      {getStyles(['headerBackContainer_background_gradient'])?.colorGradient && 
      <LinearGradient
        colors={getStyles(['headerBackContainer_background_gradient']).colorGradient}
        style={StyleSheet.absoluteFill}
        pointerEvents="none"
      />}

      <View style={getStyles(['headerContainerInner'])} id='headerContainerInner'>

        <View style={getStyles(['headerContainerInnerCompLeft', 'headerWithBackContainerInnerCompLeft'])} id='headerContainerInnerCompLeft headerWithBackContainerInnerCompLeft'>
          {!hideBackButton && <CustomPressable style={getStyles(['backIconContainer', 'headerWithBackBackIconContainer'])} onPress={handleBackPress} id='backIconContainer headerWithBackBackIconContainer'>
            <ImageComp source={CHEVRON_LEFT} style={getStyles(['backIcon', 'headerWithBackBackIcon'])} id="backIcon headerWithBackBackIcon" />
            <Text style={getStyles(['backText', "headerWithBackBackText"])} id='backText headerWithBackBackText'>{customBackText || t('header.back')}</Text>
          </CustomPressable>}
        </View>

        <ImageComp source={hotelLogoImageUrl} style={getStyles(['headerContainerLogo', 'headerWithBackContainerLogo'])} id="headerContainerLogo headerWithBackContainerLogo" />

        <View style={getStyles(['headerContainerInnerCompRight'])} id='headerContainerInnerCompRight'>
            {handleCustomCancelClick && <CustomPressable style={getStyles(['backIconContainer', 'headerWithBackBackIconContainer'])} onPress={handleCustomCancelClick} id='backIconContainer headerWithBackBackIconContainer'>
                <Text style={getStyles(['backText', "headerWithBackBackText"])} id='backText headerWithBackBackText'>{customCancelText || t('header.cancel')}</Text>
            </CustomPressable>}
        </View>
      </View>
    </View>
  );
};


export default memo(HeaderWithBack);
